import { usePlanIsChangeOnlyOption as useIsChangeOnlyOption } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-only-change-option/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanIsChangeOnlyOption = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { isChangeOnlyOption } = viewModel;

	return useIsChangeOnlyOption({
		isChangeOnlyOption,
		onSetViewModel,
	});
};
